import { IMfeRouterService } from '../../../services/mfeRouterService';
import bindAllMethods from '../../../utils/bindAllMethods';
import { MFERouterInterfaceType } from './types';
import { getServices } from '../../../infra/startup';

class MFERouterInterface {
  private _MFERouterService: IMfeRouterService;

  constructor() {
    const services = getServices();
    this._MFERouterService = services.mfeRouterService;
    bindAllMethods(this);
  }

  public getInterface(): MFERouterInterfaceType {
    return {
      start: this._MFERouterService.start,
      getState: this._MFERouterService.getState,
      listen: this._MFERouterService.listen,
      useReactHook: this._MFERouterService.useReactHook
    };
  }
}

export default MFERouterInterface;
